<template>
  <div>
    <vs-popup title="Reason" :active.sync="reasonModal">
      <div class="text-center">
        <h5>Reason For approval</h5>
        <div class="vx-row mt-5">
          <div class="vx-col w-full">
            <vs-textarea v-model="reason" class="mb-4" rows="4" counter="240" />
            <div class="text-left" v-if="showRCM == 1">
              <h6>RCM Applicable</h6>
              <vs-switch square v-model="rcm_applicable">
                <template #off>
                  <span class="text-sm font-bold">N</span>
                </template>
                <template #on>
                  <span class="text-sm font-bold">Y</span>
                </template>
              </vs-switch>
            </div>
            <vs-button
              color="success"
              type="filled"
              @click="onSubmit"
              class="mr-3"
            >
              Submit
            </vs-button>

            <vs-button color="danger" type="filled" @click="privStatus">
              Cancel
            </vs-button>
          </div>
        </div>
      </div>
    </vs-popup>

    <div class="flex flex-wrap items-baseline justify-end">
      <div
        class="w-full sm:w-1/2 md:w-1/4 mb-3 lg:mb-0 sm:pr-2"
        v-if="selectedRows.length > 0"
      >
        <vs-button
          class="w-full"
          size="sm"
          v-if="selectedRows.length > 0"
          @click="
            () => {
              this.reasonModal = true;
            }
          "
        >
          Approve Selected
        </vs-button>
      </div>

      <div class="w-full sm:w-1/2 md:w-1/4"></div>

      <div class="w-full sm:w-1/2 md:w-1/4 mb-3 sm:mb-0 sm:pr-2">
        <!-- <h6>GST Filter</h6> -->
        <multiselect
          label="label"
          trackBy="value"
          class="w-full"
          v-model="GST_filter"
          :options="GST_filter_options"
          :searchable="true"
          open-direction="bottom"
          placeholder="GST Filter"
          deselect-label="Remove"
          select-label=""
        />
      </div>

      <div class="w-full sm:w-1/2 md:w-1/4">
        <!-- <h6>Project</h6> -->
        <multiselect
          label="project_name"
          trackBy="project_id"
          class="w-full"
          v-model="project"
          :options="projectList"
          :searchable="true"
          open-direction="bottom"
          placeholder="Select Project"
          deselect-label="Remove"
          autocomplete="off"
        />
      </div>
    </div>
    <AgGridVue
      :gridOptions="gridOptions"
      :getRowId="(params) => params.data.purchase_id"
      class="ag-theme-material w-100 my-4 ag-grid-table"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="listData"
      :rowSelection="'multiple'"
      @selection-changed="onSelectionChanged"
      :paginationPageSize="paginationPageSize"
      suppressRowClickSelection
    />
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import imagePopUp from "../projects/imagePopUp.vue";
import editPoOrder from "../projects/editPoOrder.vue";
import ExpenseService from "@/services/expenseService.js";
import ProjectService from "@/services/projectService.js";
export default {
  props: {
    expenseStatus: { type: Number, required: true },
    isMyPO: { type: Boolean, default: false },
  },
  components: { AgGridVue, editPoOrder, imagePopUp },
  computed: {
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 100;
    },
  },
  watch: {
    project() {
      this.getListdata();
    },
    GST_filter() {
      this.getListdata();
    },
  },
  data() {
    return {
      showRCM: 0,
      gridOptions: {},
      maxPageNumbers: 4,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [
        {
          headerName: "  ",
          field: "name",
          width: 70,
          headerCheckboxSelection: true,
          checkboxSelection: true,
        },
        {
          headerName: "Project",
          field: "project_name",
        },
        {
          headerName: "Name",
          field: "po_name",
          minWidth: 200,
          filter: true,
        },
        {
          headerName: "User",
          field: "user_name",
          minWidth: 200,
          maxWidth: 300,
          filter: true,
        },
        {
          headerName: "PO Type",
          field: "is_var",
          minWidth: 200,
          maxWidth: 300,
          cellRenderer: function(params) {
            let txt = "";
            if (params.data.hasOwnProperty("is_var")) {
              txt = `<span class="rounded p-2 bg-info font-bold text-white">${
                params.data.is_var == 0
                  ? "Expense"
                  : params.data.is_var == 1
                  ? "VAR"
                  : params.data.is_var == 2
                  ? "CN"
                  : params.data.is_var == 3
                  ? "PCR"
                  : params.data.is_var == 4
                  ? "FR"
                  : params.data.is_var == 5
                  ? "FRR"
                  : "NA"
              }</span>`;
            } else {
              txt =
                '<span class="rounded p-2 bg-danger font-bold text-white">NA</span>';
            }
            return txt;
          },
        },
        {
          headerName: "VHC Code",
          field: "VHC_code",
          filter: true,
          width: 300,
        },
        {
          headerName: "Description",
          field: "purchase_description",
          filter: true,
          maxWidth: 300,
        },
        {
          headerName: "Amount",
          field: "total",
          filter: true,
          width: 150,
        },
        {
          headerName: "GST Name",
          field: "gst_name",
          width: 200,
          cellRenderer: function(params) {
            return params.data.hasOwnProperty("gst_name") &&
              params.data.gst_name
              ? params.data.gst_name
              : '<span class="rounded p-2 bg-danger font-bold text-white">NA</span>';
          },
        },
        {
          headerName: "GST Amount",
          field: "gst_amount",
          width: 150,
          cellRenderer: function(params) {
            return params.data.hasOwnProperty("gst_id") &&
              params.data.gst_id &&
              params.data.hasOwnProperty("gst_amount")
              ? params.data.gst_amount
              : '<span class="rounded p-2 bg-danger font-bold text-white">NA</span>';
          },
        },
        {
          headerName: "Total Amount",
          field: "formattedAmount",
          width: 150,
        },
        {
          headerName: "Multiple Images",
          field: "purchase_image",
          filter: true,
          width: 200,
          sortable: false,
          cellRendererFramework: imagePopUp,
        },
        {
          headerName: "Verified Status",
          field: "is_verified",
          width: 200,
          cellRenderer: function(params) {
            return params.value == 1
              ? `<span class="rounded p-2 bg-success font-bold text-white">Verified</span>`
              : `<span class="rounded p-2 bg-warning font-bold text-white">Not Verified</span>`;
          },
        },
        {
          headerName: "Level 1 Comment",
          field: "level_1_comment",
          filter: true,
          width: 350,
        },
        {
          headerName: "Level 3 Comment",
          field: "level_3_comment",
          filter: true,
          width: 350,
        },
      ],
      listData: [],
      selectedRows: [],
      projectList: [],
      project: null,
      reasonModal: false,
      reason: "",
      GST_filter_options: [
        { label: "All", value: 2 },
        { label: "With GST", value: 1 },
        { label: "Non GST", value: 0 },
      ],
      GST_filter: null,
      rcm_applicable: false,
    };
  },
  methods: {
    getListdata() {
      this.$vs.loading();
      this.selectedRows = [];
      let filters = { purchaseStatus: this.expenseStatus || 0, isDashboard: 1 };
      if (this.project) {
        filters.project_id = this.project.project_id;
      }
      if (this.GST_filter) {
        filters.gst_filter = this.GST_filter.value;
      }

      /*  ExpenseService.getExpenseData(filters)
        .then((response) => {
          const { data } = response;
          if (data.Status && data.data.length > 0) {
            this.listData = data.data;
          } else {
            this.listData = [];
          }
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log("error :", error);
        });
*/
      if (!this.isMyPO) {
        ExpenseService.getUserExpenses(filters)
          .then((response) => {
            const { data } = response;
            if (data.Status && data.data.length > 0) {
              this.listData = data.data;
            } else {
              this.listData = [];
            }
            this.$vs.loading.close();
          })
          .catch((error) => {
            this.$vs.loading.close();
            console.log("error :", error);
          });
      } else {
        ExpenseService.getMyExpenses(filters)
          .then((response) => {
            const { data } = response;
            if (data.Status && data.data.length > 0) {
              this.listData = data.data;
            } else {
              this.listData = [];
            }
            this.$vs.loading.close();
          })
          .catch((error) => {
            this.$vs.loading.close();
            console.log("error :", error);
          });
      }
    },

    onCellClicked(a, b, c) {
      console.log("a, b, c => ", a, b, c);
    },

    onSelectionChanged() {
      const selectedRows = this.gridApi.getSelectedRows();
      this.selectedRows = selectedRows;
    },

    getProjectsList() {
      ProjectService.getAllProjects({}, localStorage.getItem("user_id"))
        .then((response) => {
          if (response.data.Status) {
            this.projectList = response.data.data;
          } else {
            this.projectList = [];
          }
        })
        .catch((error) => console.log("Error => ", error.message));
    },

    approveSelected() {
      const selectedExpense = this.selectedRows.map((item) => item.purchase_id);
      if (!selectedExpense.length) {
        return this.$vs.notify({
          title: "Warning!",
          text: "Expense(s) not selected.",
          iconPack: "feather",
          icon: "check_box",
          color: "warning",
        });
      }

      ExpenseService.approveMultipleExpenses({
        selectedExpense,
        reason: this.reason,
        rcm_applicable: this.rcm_applicable ? 1 : 0,
      })
        .then((response) => {
          const { data } = response;
          if (!data.Status) {
            return this.$vs.notify({
              title: "Warning!",
              text: data.Message || "Expense(s) not selected.",
              iconPack: "feather",
              icon: "check_box",
              color: "warning",
            });
          }
          this.getListdata();
          this.selectedRows = [];
          this.$vs.loading.close();
          return this.$vs.notify({
            title: "Success!",
            text:
              data.Message.replace(/\n/g, "<br />") || "Expense(s) approved.",
            iconPack: "feather",
            icon: "check_box",
            color: "success",
            time: 60000,
          });
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log("error :", error);
        });
    },

    onSubmit() {
      if (!this.reason) {
        return this.$vs.notify({
          title: "Please provide a reason!",
          iconPack: "feather",
          icon: "check_box",
          color: "warning",
        });
      }
      this.approveSelected();
      this.reasonModal = false;
    },

    privStatus() {
      this.reasonPopup = false;
      this.reason = "";
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.getListdata();
    this.getProjectsList();
    const isMultipleApprovalAllowed =
      localStorage.getItem("allow_multiple_approval") || 0;
    this.showRCM = localStorage.getItem("show_rcm_applicable") || 0;

    const userRole = localStorage.getItem("UserRole");
    if (
      this.expenseStatus !== 0 ||
      this.isMyPO ||
      (isMultipleApprovalAllowed == 0 && userRole !== "Admin")
    ) {
      this.columnDefs.shift();
    }
  },
};
</script>
